<!--
  Configuration editor (popup content). One row per `config` setting: the key as a label and a control
  whose type is inferred from the stored value (boolean → switch, numeric → number box, ISO date → date
  box, else → text). Save persists only the changed rows. Launched from the user profile dropdown.
-->
<div class="cfg-editor">
  <!-- Warning banner — these are live system settings. -->
  <div class="cfg-warning" role="alert">
    <strong>Warning:</strong> changing these options will affect the way the system works. Only make
    changes if directed by OnTap Data.
  </div>

  <dx-load-panel
    [visible]="loading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="false"
    [position]="{ of: '.cfg-editor' }"
  ></dx-load-panel>

  @if (loadError) {
    <p class="cfg-error" role="alert">Couldn't load configuration. Please close and try again.</p>
  }

  @if (!loading && !loadError && configs.length === 0) {
    <p class="cfg-empty">No configuration settings found.</p>
  }

  @if (!loadError && configs.length > 0) {
    <div class="cfg-list">
      @for (c of configs; track c.config_key) {
        <div class="cfg-row">
          <label class="cfg-label" [attr.for]="'cfg-' + c.config_key">{{ c.config_key }}</label>
          <div class="cfg-control">
            @switch (c.controlType) {
              @case ('boolean') {
                <dx-switch
                  [(value)]="c.boolValue"
                  [elementAttr]="{ id: 'cfg-' + c.config_key }"
                ></dx-switch>
              }
              @case ('number') {
                <!-- [value]+$any avoids DevExtreme's strict-number [(value)] type error on nullable values. -->
                <dx-number-box
                  [value]="$any(c.numberValue)"
                  [showSpinButtons]="false"
                  [inputAttr]="{ id: 'cfg-' + c.config_key, 'aria-label': c.config_key }"
                  (onValueChanged)="c.numberValue = $event.value"
                ></dx-number-box>
              }
              @case ('date') {
                <dx-date-box
                  type="date"
                  displayFormat="dd MMM yyyy"
                  [value]="$any(c.dateValue)"
                  [inputAttr]="{ id: 'cfg-' + c.config_key, 'aria-label': c.config_key }"
                  (onValueChanged)="c.dateValue = $event.value"
                ></dx-date-box>
              }
              @default {
                <dx-text-area
                  [(value)]="c.textValue"
                  [autoResizeEnabled]="true"
                  [minHeight]="34"
                  [inputAttr]="{ id: 'cfg-' + c.config_key, 'aria-label': c.config_key }"
                ></dx-text-area>
              }
            }
          </div>
        </div>
      }
    </div>
  }

  <div class="cfg-actions">
    <dx-button text="Cancel" stylingMode="text" [disabled]="saving" (onClick)="cancel()"></dx-button>
    <dx-button
      text="Save"
      type="default"
      stylingMode="contained"
      [disabled]="saving || loading || !hasChanges"
      (onClick)="save()"
    ></dx-button>
  </div>
</div>
